import { render, staticRenderFns } from "./OtrosImpedimentosSalud.vue?vue&type=template&id=295ad5d4"
import script from "./OtrosImpedimentosSalud.vue?vue&type=script&lang=js"
export * from "./OtrosImpedimentosSalud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports